import { useEffect, useState } from "react";
import Header from "../../components/CommonComponents/Header";
// import Button from "../../components/CommonComponents/Button";
import axiosInstance from "../../../Fbaseurl";
import ExcelJS from "exceljs";

import "./index.css";
import { useMediaQuery } from "@mui/material";
import NavDownloadArrow from "../../../assets/NavDownloadArrow.svg";
import DownloadShape from "../../../assets/DownloadShape.svg";
import Union from "../../../assets/Union.svg";
import FileIcon from "../../../assets/FileIcon.svg";
import DeleteIcon from "../../../assets/DeleteIcon.svg";
import ArrowUpload from "../../../assets/ArrowUpload.svg";
import LoadingButton from "@mui/lab/LoadingButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { showToast } from "../../../store/reducers/ToastMessageReducer";
import { useDispatch, useSelector } from "react-redux";
import { getRoleBasePath } from "../../../CommonUtils/roles";
const ImportTaxcredits = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const currentRole = useSelector((state) => state.App.currentRole);
  const roleBasePath = getRoleBasePath(currentRole);
  const [processing, setProcessing] = useState(false); // State to track processing status
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [taxCredits, setTaxCredits] = useState([]);
  // const [eligibilityCriteria, setEligibilityCriteria] = useState([]);
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    const { size, type } = file;
    console.log("36::", type);
    const validFileTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "application/vnd.ms-excel", // .xls
    ];
    if (file && validFileTypes.includes(file.type)) {
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(file);

      // Assuming the first worksheet contains the data
      const worksheet = workbook.getWorksheet(1);
      const rowCount = worksheet.rowCount;
      console.log("ROW", rowCount);
      if (rowCount <= 1) {
        dispatch(
          showToast({
            type: "error",
            message: "Please upload a file with valid data",
          })
        );
        return;
      }

      if (rowCount > 500) {
        dispatch(
          showToast({
            type: "error",
            message:
              "The file contains more than 500 records. Please upload a file with 500 records or less.",
          })
        );
        return;
      }
      setSelectedFile(file);
      setUploadedFileName(file.name);
    } else {
      dispatch(
        showToast({
          type: "error",
          message: "Please upload excel format files only",
        })
      );
    }

    event.target.value = "";
  };
  const handleCancel = () => { };

  const handleDelete = () => {
    setUploadedFileName("");
    setSelectedFile(null);
  };

  const convertNaicsDataIntoReqFormat = (data, type) => {
    if (data?.length) {
      let updatedData = [];
      let modifiedData = data.split(",");
      modifiedData.forEach((ele) => {
        let obj;
        if (type === "CITIES") {
          obj = {
            name: ele.trim(),
          };
        } else {
          obj = {
            code: ele.trim(),
          };
        }
        updatedData.push(obj);
      });
      return updatedData;
    }
  };

  const handleEligibilityCriteria = (data) => {
    let newData = [];
    data.forEach((item) => {
      if (String(item.value).toLowerCase() === "yes") {
        let obj = {
          propertyName: item.name,
        };
        newData.push(obj);
      }
    });

    return newData;
  };

  // const handleGenerateCreditMap = async (event) => {
  //   if (!selectedFile) return;
  //   setProcessing(true);
  //   setUploadedFileName(selectedFile.name);
  //   try {
  //     let taxcredits = [];

  //     const reader = new FileReader();
  //     reader.readAsArrayBuffer(selectedFile);
  //     reader.onload = async () => {
  //       const buffer = reader.result;
  //       const workbook = new ExcelJS.Workbook();
  //       await workbook.xlsx.load(buffer);
  //       const worksheet = workbook.getWorksheet("Sheet1");
  //       worksheet.eachRow(async (row, rowNumber) => {
  //         if (rowNumber !== 1) {
  //           // Skip the header row
  //           const [
  //             _,
  //             name,
  //             description,
  //             qualificationDifficulty,
  //             requiresNegotiation,
  //             avgCreditPerEmployee,
  //             avgCreditPerNewHire,
  //             avgJobGrowthCreditPerNewHire,
  //             lookBackYears,
  //             expirationDate,
  //             includedNaicsCodes,
  //             eligibilityCriteria_includedNaicsCodes,
  //             excludedNaicsCodes,
  //             eligibilityCriteria_excludedNaicsCodes,
  //             businessSizes,
  //             eligibilityCriteria_businessSizes,
  //             locationHeadcounts,
  //             eligibilityCriteria_locationHeadcounts,
  //             totalHeadcounts,
  //             eligibilityCriteria_totalHeadcounts,
  //             yearsInbusiness,
  //             eligibilityCriteria_yearsInbusiness,
  //             annualNewHires,
  //             eligibilityCriteria_annualNewHires,
  //             states,
  //             eligibilityCriteria_states,
  //             cities,
  //             eligibilityCriteria_cities,
  //             fipsCodes,
  //             eligibilityCriteria_fipsCodes,
  //             censusTracts,
  //             eligibilityCriteria_censusTracts,
  //           ] = row.values;
  //           console.log(`Row ${rowNumber}:`, row.values);

  //           let payload = {
  //             name: name?.toString(),
  //             description: description?.toString(),
  //             qualificationDifficulty: Number(qualificationDifficulty),
  //             requiresNegotiation:
  //               String(requiresNegotiation).toLowerCase() === "true"
  //                 ? true
  //                 : false,
  //             avgCreditPerEmployee: Number(avgCreditPerEmployee),
  //             avgCreditPerNewHire:
  //               Number(avgCreditPerNewHire) || Number(avgCreditPerNewHire),
  //             avgJobGrowthCreditPerNewHire: Number(
  //               avgJobGrowthCreditPerNewHire
  //             ),
  //             lookBackYears: Number(lookBackYears),
  //             expirationDate: expirationDate,
  //             includedNaicsCodes:
  //               convertNaicsDataIntoReqFormat(includedNaicsCodes),
  //             excludedNaicsCodes:
  //               convertNaicsDataIntoReqFormat(excludedNaicsCodes),
  //             businessSizes: convertNaicsDataIntoReqFormat(businessSizes),
  //             locationHeadcounts:
  //               convertNaicsDataIntoReqFormat(locationHeadcounts),
  //             totalHeadcounts: convertNaicsDataIntoReqFormat(totalHeadcounts),
  //             yearsInbusiness: convertNaicsDataIntoReqFormat(yearsInbusiness),
  //             minimumAnnualNewHires: Number(annualNewHires),
  //             states: convertNaicsDataIntoReqFormat(states),
  //             cities: convertNaicsDataIntoReqFormat(cities, "CITIES"),
  //             fipsCodes: convertNaicsDataIntoReqFormat(fipsCodes),
  //             censusTracts: convertNaicsDataIntoReqFormat(censusTracts),
  //             eligibilityCriteria: handleEligibilityCriteria([
  //               {name: "IncludedNaicsCodes", value: eligibilityCriteria_includedNaicsCodes},
  //               {name: "ExcludedNaicsCodes", value: eligibilityCriteria_excludedNaicsCodes},
  //               {name: "BusinessSizes", value: eligibilityCriteria_businessSizes},
  //               {name: "LocationHeadcounts", value: eligibilityCriteria_locationHeadcounts},
  //               {name: "TotalHeadcounts", value: eligibilityCriteria_totalHeadcounts},
  //               {name: "YearsInbusiness", value: eligibilityCriteria_yearsInbusiness},
  //               {name: "AnnualNewHires", value: eligibilityCriteria_annualNewHires},
  //               {name: "States", value: eligibilityCriteria_states},
  //               {name: "Cities", value: eligibilityCriteria_cities},
  //               {name: "FIPSCodes", value: eligibilityCriteria_fipsCodes},
  //               {name: "CensusTracts", value: eligibilityCriteria_censusTracts}
  //             ]),

  //           };
  //           console.log('PAYLOAD', payload)
  //           // return ;
  //           try {
  //             const response = await axiosInstance.post("/taxCredits", payload);
  //             setTaxCredits((prevData) => [...prevData, ...response.data]);
  //             setProcessing(false);
  //             navigate('/superadmin/dashboard/taxcredits')
  //           } catch (error) {
  //             console.error(`Error fetching data for Row ${rowNumber}:`, error);
  //           }
  //         }
  //       });
  //     };
  //     reader.onerror = (error) => {
  //       console.error("Error reading file:", error);
  //     };
  //   } catch (error) {
  //     console.error("Error during login:", error);
  //   }
  //   dispatch(
  //     showToast({
  //       type: "success",
  //       message: "Tax credits generated successfully",
  //     })
  //   );
  // };

  const handleGenerateCreditMap = async (event) => {
    if (!selectedFile) return;
    setProcessing(true);
    setUploadedFileName(selectedFile.name);

    try {
      let taxcredits = [];
      let successCount = 0;
      let failureCount = 0;

      const reader = new FileReader();
      reader.readAsArrayBuffer(selectedFile);
      reader.onload = async () => {
        const buffer = reader.result;
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(buffer);
        const worksheet = workbook.getWorksheet("Sheet1");

        // Collect promises for all API calls
        const apiPromises = [];

        worksheet.eachRow((row, rowNumber) => {
          if (rowNumber !== 1) {
            // Skip the header row
            const [
              _,
              name,
              description,
              qualificationDifficulty,
              requiresNegotiation,
              avgCreditPerEmployee,
              avgCreditPerNewHire,
              avgJobGrowthCreditPerNewHire,
              lookBackYears,
              expirationDate,
              includedNaicsCodes,
              eligibilityCriteria_includedNaicsCodes,
              excludedNaicsCodes,
              eligibilityCriteria_excludedNaicsCodes,
              businessSizes,
              eligibilityCriteria_businessSizes,
              locationHeadcounts,
              eligibilityCriteria_locationHeadcounts,
              totalHeadcounts,
              eligibilityCriteria_totalHeadcounts,
              yearsInbusiness,
              eligibilityCriteria_yearsInbusiness,
              annualNewHires,
              eligibilityCriteria_annualNewHires,
              states,
              eligibilityCriteria_states,
              cities,
              eligibilityCriteria_cities,
              fipsCodes,
              eligibilityCriteria_fipsCodes,
              censusTracts,
              eligibilityCriteria_censusTracts,
            ] = row.values;

            let payload = {
              name: name?.toString(),
              description: description?.toString(),
              qualificationDifficulty: Number(qualificationDifficulty) || 0,
              requiresNegotiation:
                String(requiresNegotiation).toLowerCase() === "yes"
                  ? true
                  : false,
              avgCreditPerEmployee: Number(avgCreditPerEmployee),
              avgCreditPerNewHire:
                Number(avgCreditPerNewHire) || Number(avgCreditPerNewHire),
              avgJobGrowthCreditPerNewHire: Number(
                avgJobGrowthCreditPerNewHire
              ),
              lookBackYears: Number(lookBackYears),
              expirationDate: expirationDate,
              includedNaicsCodes:
                convertNaicsDataIntoReqFormat(includedNaicsCodes),
              excludedNaicsCodes:
                convertNaicsDataIntoReqFormat(excludedNaicsCodes),
              businessSizes: convertNaicsDataIntoReqFormat(businessSizes),
              locationHeadcounts:
                convertNaicsDataIntoReqFormat(locationHeadcounts),
              totalHeadcounts: convertNaicsDataIntoReqFormat(totalHeadcounts),
              yearsInbusiness: convertNaicsDataIntoReqFormat(yearsInbusiness),
              minimumAnnualNewHires: Number(annualNewHires),
              states: convertNaicsDataIntoReqFormat(states),
              cities: convertNaicsDataIntoReqFormat(cities, "CITIES"),
              fipsCodes: convertNaicsDataIntoReqFormat(fipsCodes),
              censusTracts: convertNaicsDataIntoReqFormat(censusTracts),
              eligibilityCriteria: handleEligibilityCriteria([
                {
                  name: "IncludedNaicsCodes",
                  value: eligibilityCriteria_includedNaicsCodes,
                },
                {
                  name: "ExcludedNaicsCodes",
                  value: eligibilityCriteria_excludedNaicsCodes,
                },
                {
                  name: "BusinessSizes",
                  value: eligibilityCriteria_businessSizes,
                },
                {
                  name: "LocationHeadcounts",
                  value: eligibilityCriteria_locationHeadcounts,
                },
                {
                  name: "TotalHeadcounts",
                  value: eligibilityCriteria_totalHeadcounts,
                },
                {
                  name: "YearsInbusiness",
                  value: eligibilityCriteria_yearsInbusiness,
                },
                {
                  name: "AnnualNewHires",
                  value: eligibilityCriteria_annualNewHires,
                },
                { name: "States", value: eligibilityCriteria_states },
                { name: "Cities", value: eligibilityCriteria_cities },
                { name: "FIPSCodes", value: eligibilityCriteria_fipsCodes },
                {
                  name: "CensusTracts",
                  value: eligibilityCriteria_censusTracts,
                },
              ]),
              isActive: true,
            };

            // Push API calls to the array
            apiPromises.push(
              axiosInstance
                .post("/taxCredits", payload)
                .then((response) => {
                  successCount++;
                  // setTaxCredits((prevData) => [...prevData, ...response.data]);
                })
                .catch((error) => {
                  failureCount++;
                  console.error(
                    `Error fetching data for Row ${rowNumber}:`,
                    error
                  );
                })
            );
          }
        });

        // Wait for all promises to resolve
        await Promise.all(apiPromises);

        // Show toast with the result count
        if (successCount > 0) {
          dispatch(
            showToast({
              type: "success",
              message: `Tax credits generated successfully. Success: ${successCount}, Failed: ${failureCount}`,
            })
          );
        } else {
          dispatch(
            showToast({
              type: "error",
              message: `Failed to generate tax credits. Failed: ${failureCount}`,
            })
          );
        }

        setProcessing(false);
        navigate("/superadmin/dashboard/taxcredits");
      };

      reader.onerror = (error) => {
        console.error("Error reading file:", error);
      };
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  const handleDownload = () => {
    // Create a new workbook
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    // Add header row
    worksheet.addRow([
      "Tax Credit Name",
      "Description",
      "Difficulty Rating",
      "Requires Negotiation",
      "Available Credit",
      "New Hire Credit",
      "Job Growth Credit",
      "Look Back Months",
      "Expires",
      "NAICS Code",
      "NAICS Code Eligibility criteria",
      "Exclude NAICS Codes",
      "Exclude NAICS Codes Eligibility criteria",
      "Size of Business",
      "Size of Business Eligibility criteria",
      "Headcount Location",
      "Headcount Location Eligibility criteria",
      "Headcount Total",
      "Headcount Total Eligibility criteria",
      "Years in Business",
      "Years in Business Eligibility criteria",
      "Annual New Hires",
      "Annual New Hires Eligibility criteria",
      "Eligible States",
      "Eligible States Eligibility criteria",
      "Cities",
      "Cities Eligibility criteria",
      "FIPS Codes",
      "FIPS Codes Eligibility criteria",
      "Census Tracts",
      "Census Tracts Eligibility criteria",
    ]);

    // Generate a unique filename
    const fileName = "Taxcredit_template.xlsx";

    // Save the workbook
    workbook.xlsx
      .writeBuffer()
      .then((buffer) => {
        // Convert the buffer to a Blob
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Create a link element to trigger the download
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;

        // Simulate a click event to trigger the download
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error generating Excel file:", error);
      });
  };
  const backNavigation = () => {
    navigate(`${roleBasePath}/dashboard/taxcredits?page=1`);
  };
  return (
    <>
      <div>
        <Header />
        <div className="col-11 mx-auto pt-4">
          <div className="d-flex align-items-center gap-4">
            <ArrowBackIcon
              className="back-btn"
              onClick={() => backNavigation()}
            />
            <p className="fw-bold fs-4 m-0">Tax credit Library</p>
          </div>
          <div className="container">
            <header className="header">{/* Header content */}</header>

            <div className="d-lg-flex d-md-flex">
              <div
                className={`col-lg-6 col-md-6 col-sm-12 ${
                  !isMobile ? "px-3" : ""
                  }`}
              >
                <div className="downloadCard firstcard">
                  <h3 className="card_title textTitleForDocument">
                    Download Tax Credit Data Template
                  </h3>
                  <div className="taxcredit_card docummentCard gap-3">
                    <img
                      src={DownloadShape}
                      width="20px"
                      height="20px"
                      alt="download"
                    ></img>

                    <LoadingButton
                      variant="contained"
                      color="primary"
                      size="medium"
                      // sx={{ textTransform: "none", borderRadius: "8px" }}
                      onClick={handleDownload}
                      sx={{
                        textTransform: "none",
                        borderRadius: "8px",
                        backgroundColor: '#FFCC33',
                        color: '#000',
                        borderColor: '#FFCC33',
                        boxShadow: 'none',
                        '&:hover': {
                          backgroundColor: '#e6b800',
                          borderColor: '#e6b800',
                          boxShadow: 'none',
                        },
                        '&:active': {
                          boxShadow: 'none',
                        },
                        '&:focus': {
                          boxShadow: 'none',
                        },
                      }}

                    >
                      <img
                        src={NavDownloadArrow}
                        width="20px"
                        height="20px"
                        alt="download"
                      ></img>{" "}
                      Download document
                    </LoadingButton>
                  </div>
                </div>
              </div>
              <div
                className={`col-lg-6 col-md-6 col-sm-12 ${
                  !isMobile ? "px-3" : ""
                  }`}
              >
                <div
                  className={`${
                    uploadedFileName ? "taxcredit_card" : "downloadCard"
                    } firstcard ${isMobile ? "border-0 p-0 pt-4" : ""}`}
                >
                  <h3 className="card_title textTitleForDocument">
                    Upload Tax credit Data File
                  </h3>
                  <div
                    className={`taxcredit_card docummentCardUplod gap-3 ${
                      uploadedFileName ? "mb-12" : ""
                      }`}
                  >
                    <img
                      src={Union}
                      width="20px"
                      height="20px"
                      alt="union"
                    ></img>
                    <h3 className="font-14 fw-bold">Add a document</h3>
                    <input
                      type="file"
                      onInput={handleFileChange}
                      id="upload_input"
                      className="upload_input"
                    />

                    {!processing && (
                      <label htmlFor="upload_input" className="upload_label">
                        <img
                          src={ArrowUpload}
                          width="20px"
                          height="20px"
                          alt="upload"
                        ></img>{" "}
                        Upload
                      </label>
                    )}
                    {processing && (
                      <div className="loader_container">
                        <div className="loader"></div>
                        <button
                          className="cancel_genreate_button"
                          onClick={handleCancel}
                        >
                          Cancel
                        </button>
                      </div>
                    )}
                  </div>
                  {uploadedFileName && !processing && (
                    <div className={` uploadDocumnetFile col-12`}>
                      <div style={{ float: "left" }}>
                        <div
                          className={`card_title ${isMobile ? "ellipsis" : ""}`}
                        >
                          <img
                            src={FileIcon}
                            width="40px"
                            height="40px"
                            alt="File"
                            style={{ marginRight: "8px" }}
                          ></img>
                          {uploadedFileName}
                        </div>
                      </div>
                      <div>
                        <img
                          onClick={handleDelete}
                          style={{ float: "right" }}
                          src={DeleteIcon}
                          width="36px"
                          height="36px"
                          alt="Delete"
                        ></img>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* )} */}
            </div>
            {/* <div className="card-footer d-flex text-right align-self-end gap-3 mt-auto">
        
        <LoadingButton
          variant="contained"
          color="primary"
          size="medium"
          sx={{ textTransform: "none" }}
          onClick={(e) => handleGenerateCreditMap(e)}
          disabled={
            !selectedFile
          }
          loading={processing}
          >
          Generate
        </LoadingButton>
      </div> */}

            <div
              className={`card-footer d-flex text-right align-self-end gap-3 mt-auto ${
                isMobile ? "px-0 pt-3 w-100" : "px-3"
                }`}
            >
              <LoadingButton
                variant="contained"
                // color="primary"
                size="medium"
                // sx={{ textTransform: "none", borderRadius: "8px" }}
                onClick={(e) => handleGenerateCreditMap(e)}
                disabled={!selectedFile}
                loading={processing}
                className={isMobile ? "w-100" : ""}
                sx={{
                  textTransform: "none",
                  borderRadius: "8px",
                  backgroundColor: '#FFCC33',
                  color: '#000',
                  borderColor: '#FFCC33',
                  boxShadow: 'none',
                  '&:hover': {
                    backgroundColor: '#e6b800',
                    borderColor: '#e6b800',
                    boxShadow: 'none',
                  },
                  '&:active': {
                    boxShadow: 'none',
                  },
                  '&:focus': {
                    boxShadow: 'none',
                  },
                }}
              >
                Generate
              </LoadingButton>

              {/* {showMap && (
            

            <LoadingButton
              variant="contained"
              color="primary"
              size="medium"
              sx={{ textTransform: "none", borderRadius: "8px" }}
              onClick={(e) => handleGoBackToUpload(e)}
            >
              Go Back
            </LoadingButton>
          )} */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImportTaxcredits;
